import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=19531c78&scoped=true&"
import script from "./fees.vue?vue&type=script&lang=js&"
export * from "./fees.vue?vue&type=script&lang=js&"
import style0 from "./fees.vue?vue&type=style&index=0&id=19531c78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19531c78",
  null
  
)

export default component.exports